module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<a id=\"request-report\" class=\"btn btn-blue filter-panel-btn request-report-btn\"> <div>Request CSV</div> ")
    ;  if(locals.maxDays) { 
    ; __append(" <small class=\"text-muted\">(max: ")
    ; __append(escapeFn( locals.maxDays ))
    ; __append(" days)</small> ")
    ;  } 
    ; __append(" </a> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/request_report.ejs
// module id = 907
// module chunks = 1